/**
 * JK Drum Systems — Megamenu JS
 * Werkt naast Dawn's bestaande JS, raakt niets aan.
 */
(function () {
  'use strict';

  function initMegaMenus() {
    const wrappers = document.querySelectorAll('[data-mega-wrapper]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      const trigger = wrapper.querySelector('.jk-mega-trigger');
      const menu    = wrapper.querySelector('.jk-megamenu');
      if (!trigger || !menu) return;

      // Open/sluit bij klik op trigger
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        // Sluit eerst alle andere open menu's
        closeAll(wrapper);
        isOpen ? close(trigger, menu) : open(trigger, menu);
      });
    });

    // Klik buiten → sluit alles
    document.addEventListener('click', function () {
      closeAll(null);
    });

    // Klik binnen megamenu → niet sluiten
    document.querySelectorAll('.jk-megamenu').forEach(function (menu) {
      menu.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    // Escape → sluit alles
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  function open(trigger, menu) {
    trigger.setAttribute('aria-expanded', 'true');
    menu.classList.add('is-open');
  }

  function close(trigger, menu) {
    trigger.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
  }

  function closeAll(exceptWrapper) {
    document.querySelectorAll('[data-mega-wrapper]').forEach(function (wrapper) {
      if (wrapper === exceptWrapper) return;
      const trigger = wrapper.querySelector('.jk-mega-trigger');
      const menu    = wrapper.querySelector('.jk-megamenu');
      if (trigger && menu) close(trigger, menu);
    });
  }

  // Init na DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenus);
  } else {
    initMegaMenus();
  }
})();
